// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n/* 登录对话框 */\n.dialog {\n  width: 350px;\n  height: 410px;\n  padding: 10px;\n  border-radius: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
